import { useLocation } from "react-router-dom";
import { useQueryParams } from "../hooks/useQueryParams";
import HeadingOne from "../components/typography/HeadingOne";
import { BodyOne } from "../components/typography";
import { svgData } from "../constants/svg";
import googleFavicon from "../assets/illustrations/google-play-badge.png";
import appleFavicon from "../assets/illustrations/app-store-badge.png";
import checkInFavicon from "../assets/illustrations/Checkin.png";
import BlueButton from "../components/buttons/BlueButton";
import DownloadButtons from "../components/buttons/DownloadButton";
import InfoImage from "../components/info/InfoImage";
import {
  GOOGLE_PLAY_URL,
  APP_STORE_URL,
  global_tailwind_constants,
} from "../constants";
import mixpanelService from "../services/mixpanel";

const InviteLandingPage = () => {
  const location = useLocation();
  const queryParams = useQueryParams(location.search);
  const orgId = queryParams.get("orgId");
  const inviteId = queryParams.get("inviteId");

  const handleRedirect = () => {
    mixpanelService.track("App.Redeem.Invite.Driver", {
      invite_id: inviteId,
      org_id: orgId,
    });
    window.location.href = `mytripplo://redeem/driver/invite?orgId=${orgId}&inviteId=${inviteId}`;
  };

  return (
    <div className="p-12">
      <header className="flex flex-col items-center mt-8 mb-4">
        {svgData["form-logo"]()}
      </header>
      <div className="flex justify-center">
        <div className="grid grid-rows-2 place-content-between gap-20">
          <div className={global_tailwind_constants.formWidth}>
            <HeadingOne className="text-center mt-4 mb-4 text-tripplo-200">
              Welcome!
            </HeadingOne>

            <BodyOne className="text-center font-semibold py-4">
              Before we get started and redeem your invite, please make sure you
              have the mobile app installed, before clicking the button below.
            </BodyOne>

            <BodyOne className="text-center font-semibold py-4">
              If you do not have the mobile app installed please click below to
              download the Tripplo app in your App Store. Then click on the sms
              link you've been sent or come back to this page in your browser on
              your phone.
            </BodyOne>

            <DownloadButtons
              googlePlayBadgeUrl={googleFavicon}
              googlePlayUrl={GOOGLE_PLAY_URL}
              appStoreUrl={APP_STORE_URL}
              appStoreBadgeUrl={appleFavicon}
            />
            <InfoImage imageUrl={checkInFavicon} description="Check In" />

            <BodyOne className="text-center font-semibold text-red-600 p-4">
              Please note that your invite link is only valid for 3 days.
            </BodyOne>

            <BlueButton
              className="w-full"
              type="submit"
              onClick={handleRedirect}
            >
              Redirect to mobile app
            </BlueButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteLandingPage;
